/** The longest a first paint waits for its web fonts. */
export const FONT_WAIT_MS = 300;

/**
 * Resolves once these faces (CSS `font` shorthands, e.g. `400 1em Anton`)
 * have loaded, or after `ms`, whichever comes first. Painting after it means
 * the text is already in its real font, instead of a fallback that reflows
 * when the font arrives. The faces are preloaded, so it rarely waits.
 */
export function fontsReady(faces: string[], ms = FONT_WAIT_MS): Promise<void> {
  const loaded = Promise.all(
    faces.map((face) => document.fonts?.load(face)),
  ).then(
    () => undefined,
    () => undefined,
  );
  return Promise.race([
    loaded,
    new Promise<void>((resolve) => window.setTimeout(resolve, ms)),
  ]);
}
